import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-3-line text-3xl" aria-hidden="true" />
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          这个页面走丢了
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          你访问的地址可能已经被合并或者调整过。不妨从话题广场重新出发，
          那里有正在被讨论的爆料、评论区高能回复与最新的投票风向。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            回到首页
          </Link>
          <Link
            to="/topics"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            去话题广场
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}